import controller from './balanceChart.controller';
import template from './balanceChart.html';

const balanceChartComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default balanceChartComponent;



/** WEBPACK FOOTER **
 ** ./client/app/common/components/balanceChart/balanceChart.component.js
 **/